<!-- 维权页 -->
<template>
  <div class="rightProtection">
    <div class="nav-top">
      <i class="iconfont icon-zglsfanhui" @click="toIndex()"></i>
      中国律师网
    </div>
    <div class="detail-content">
      <div class="imageBox">
        <div class="imageBox-item" @click="toQueryRight('rightApplication')">
          我要维权
        </div>
        <div class="imageBox-item" @click="toQueryRight('queryRight', 'RPM')">
          维权查询
        </div>
      </div>
      <div class="menu-item" @click="toQueryRight('iframeView', 'rightflow')">
        工作流程
        <i class="iconfont icon-right"></i>
      </div>
      <div class="menu-item" @click="toQueryRight('iframeView', 'rightduty')">
        工作职责
        <i class="iconfont icon-right"></i>
      </div>
      <div class="menu-item" @click="toQueryRight('contactInformation', 'RPM')">
        联系方式
        <i class="iconfont icon-right"></i>
      </div>
      <a href="https://jubao.court.gov.cn/" target="_blank">
        <div class="menu-item">
          最高人民法院网上举报平台
          <i class="iconfont icon-right"></i>
        </div>
      </a>
      <a href="https://www.12309.gov.cn/12309/wsxf/index.shtml" target="_blank">
        <div class="menu-item">
          最高人民检察院网上信访平台
          <i class="iconfont icon-right"></i>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      from: "",
    };
  },
  created() {
    this.from = localStorage.getItem("menu");
  },
  methods: {
    toIndex() {
      this.$router.push({
        name: this.from,
      });
    },
    toQueryRight(route, type) {
      this.$router.push({
        name: route,
        params: { from: "rightProtection", type: type },
      });
      localStorage.setItem("rightType", type);
    },
  },
};
</script>
<style lang='scss' scoped>
.rightProtection {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .nav-top {
    position: relative;
    width: 100%;
    height: 2.75rem;
    background: rgba(255, 255, 255, 0);
    text-align: center;
    font-weight: 600;
    font-size: 1.06rem;
    color: #323233;
    line-height: 2.75rem;
    .iconfont {
      position: absolute;
      left: 1rem;
      top: 0;
      font-size: 1.25rem;
      color: #323233;
    }
  }
  .detail-content {
    width: 100%;
    height: calc(100% - 2.75rem);
    padding: 1.56rem 1rem;
    box-sizing: border-box;
    background: #f7f8fa;
    overflow: auto;
    .imageBox {
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 4.88rem;
      font-weight: 500;
      font-size: 1rem;
      color: rgba(0, 0, 0, 0.85);
      line-height: 1.38rem;
      text-align: right;
      .imageBox-item {
        width: 10.38rem;
        height: 100%;
        padding: 1.06rem 1.13rem 0 0;
        box-sizing: border-box;
        background-image: url("@/assets/images/right1.png");
        background-repeat: no-repeat;
        background-size: cover;
      }
      .imageBox-item:last-child {
        background-image: url("@/assets/images/right2.png");
      }
    }
    .menu-item {
      margin-top: 0.94rem;
      width: 100%;
      height: 3.5rem;
      padding: 0 1.13rem;
      box-sizing: border-box;
      line-height: 3.5rem;
      background: #ffffff;
      border-radius: 0.75rem;
      font-weight: 400;
      font-size: 1rem;
      color: rgba(0, 0, 0, 0.85);
      .iconfont {
        float: right;
        font-size: 1rem;
        color: #969799;
      }
    }
  }
}
</style>